export default __webpack_public_path__ + "static/redislide1-c9e2352e376bf2487f6f82aca878fcb3.jpg";